@if (items.length === 0) {
  <span class="text-subdued px-8 py-2 text-sm">
    No Folders found
  </span>
}

<div appSelectableList #appSelectableList="appSelectableList" [deselectOnReclick]="false">
  <app-sidebar-item
    class="rounded [&:not(.drag-over)]:hover:bg-hover"
    *nestedFor="
      let sheetFolder of items;
      let index = index;
      let depth = depth;
      let expandable = expandable;
      let itemExpanded = expanded;
      stateKey: treeStateKey;
    "
    [title]="sheetFolder.title"
    [depth]="team ? depth + 2 : depth"
    [badge]="{ template: badgeTemplate, context: { flagged: sheetFolder.flagged, pinned: sheetFolder.pinned, snoozed: sheetFolder.snoozed, followed: sheetFolder.followed } }"
    iconSlot="none"
    [expandable]="expandable"
    [expanded]="itemExpanded.value"
    [active]="selectedItemsIds | includesBy : sheetFolder?.id"
    (onExpand)="itemExpanded.next($event)"
    (appClick)="openItem(sheetFolder)"
    (appDblClick)="handleDblClick(sheetFolder)"
    [appSheetFolderContextMenu]="sheetFolder"
    [appSelectable]="sheetFolder?.id"
    [appSelectablePosition]="index"
    [appSelectableIdentifier]="sheetFolder?.id"
    [appSelectableListRef]="appSelectableList"

    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate(sheetFolder)"
    (appDroppableDrop)="dndDrop($event, sheetFolder)"

    appDraggable
    [appDraggableData]="items | selectedItemsDragData: selectedItemsIds: sheetFolder"
    [appDraggablePlaceholder]="placeholder"
    [appDraggablePlaceholderContext]="{ item: sheetFolder }"
    />
  </div>

  <ng-template #badgeTemplate let-flagged=flagged let-pinned=pinned let-snoozed=snoozed let-followed=followed>
    <div class="badge-template h-full flex flex-col justify-center items-center">
      @if (pinned) {
        <app-icon
          class="text-primary"
          size="xs"
          name="sapphire-pin-filled"
        />
      }
      @if (flagged) {
        <app-icon
          class="text-orange-500"
          name="sapphire-flagged-filled"
          size="xs"
        />
      }
      @if (snoozed) {
        <app-icon
          class="text-orange-500"
          name="sapphire-snooze"
          size="xs"
        />
      }
      @if (followed) {
        <app-icon
          class="text-primary"
          name="sapphire-follow-up"
          size="xs"
        />
      }
    </div>
  </ng-template>
